import React from "react";

interface SwitchDateTimelineProps {
    d_switch: Date;
    leftText: string;
    rightText: string;
}

const DAYS_BEFORE = 1;
const DAYS_AFTER = 1;

const formatDate = (date: Date): string =>
    `${date.getMonth() + 1}/${date.getDate()}`;

const formatDay = (date: Date): string =>
    date.toLocaleDateString("en-US", { weekday: "short" });

const addDays = (date: Date, days: number): Date => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
};

const SwitchDateTimeline: React.FC<SwitchDateTimelineProps> = ({
    d_switch,
    leftText,
    rightText,
}) => {
    
    const switchDate = new Date(d_switch);
    switchDate.setHours(0, 0, 0, 0);

    const days: Date[] = [];
    for (let i = -DAYS_BEFORE; i <= DAYS_AFTER; i++) {
        days.push(addDays(switchDate, i));
    }

    const switchIndex = DAYS_BEFORE; // index of switch date in the array

    return (
        <div style={{ fontFamily: "system-ui, sans-serif", padding: "24px 16px" }}>
            {/* Labels row */}
            <div style={{ display: "flex", marginBottom: 12 }}>
                <div
                    style={{
                        flex: switchIndex + 1,
                        textAlign: "center",
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#b45309",
                    }}
                >
                    {leftText}
                </div>
                <div
                    style={{
                        flex: DAYS_AFTER,
                        textAlign: "center",
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#28a745",
                    }}
                >
                    {rightText}
                </div>
            </div>

            {/* Track */}
            <div
                style={{
                    display: "flex",
                    height: 16,
                    borderRadius: 4,
                    overflow: "hidden",
                    marginBottom: 6,
                }}
            >
                <div
                    style={{
                        flex: switchIndex + 1,
                        background: "#8c9fbd",
                        borderRadius: "4px 0 0 4px",
                    }}
                />
                <div
                    style={{
                        flex: DAYS_AFTER,
                        background: "#28a745",
                        borderRadius: "0 4px 4px 0",
                    }}
                />
            </div>

            {/* Day markers */}
            <div style={{ display: "flex" }}>
                {days.map((day, i) => {
                    const isSwitch = i === switchIndex;
                    const isBefore = i <= switchIndex;

                    return (
                        <div
                            key={i}
                            style={{
                                flex: 1,
                                textAlign: "center",
                                position: "relative",
                            }}
                        >
                            {/* Tick mark */}
                            <div
                                style={{
                                    width: isSwitch ? 3 : 1,
                                    height: isSwitch ? 16 : 10,
                                    background: isSwitch
                                        ? "#111827"
                                        : isBefore
                                            ? "#8c9fbd"
                                            : "#28a745",
                                    margin: "0 auto 4px",
                                    borderRadius: 1,
                                }}
                            />

                            {/* Date label */}
                            <div
                                style={{
                                    fontSize: isSwitch ? 12 : 11,
                                    fontWeight: isSwitch ? 700 : 400,
                                    color: isSwitch ? "#111827" : "#6b7280",
                                    lineHeight: 1.3,
                                }}
                            >
                                <div>{formatDay(day)}</div>
                                <div>{formatDate(day)}</div>
                            </div>

                            {/* Switch indicator */}
                            {isSwitch && (
                                <div
                                    style={{
                                        fontSize: 10,
                                        fontWeight: 600,
                                        color: "#111827",
                                        marginTop: 4,
                                        textTransform: "uppercase",
                                        letterSpacing: "0.05em",
                                    }}
                                >
                                    Last date of effect
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SwitchDateTimeline;